export default "__VITE_ASSET__CfTFrN6b__"